import { Box, Flex } from "@chakra-ui/react";
import SvgContainer from "src/components/SvgContainer";

export default function RoundButton({
  bg,
  size,
  icon,
  iconFill,
  iconSize,
  onClick,
  children,
  borderRadius = "100%",
  showIconWithText = false,
  forceActive = false,
  forceHover = false,
  ...rest
}) {
  let backgroundBg = bg;
  let overlayBg = "transparent";

  let backgroundHoverBg = backgroundBg;
  let backgroundActiveBg = backgroundBg;

  let overlayHoverBg = overlayBg;
  let overlayActiveBg = overlayBg;

  if (bg === "primary") {
    backgroundHoverBg = "primaryLighter";
    backgroundActiveBg = "primaryDarker";
  } else if (bg === "white") {
    backgroundHoverBg = "#ebebeb";
    backgroundActiveBg = "#cccccc";
  } else if (bg === "black20") {
    backgroundHoverBg = "black12";
    backgroundActiveBg = "black8";
  } else if (bg === "black8") {
    backgroundHoverBg = "black4";
    backgroundActiveBg = "black20";
  } else {
    overlayHoverBg = "white20";
    overlayActiveBg = "black8";
  }

  if (forceHover) {
    backgroundBg = backgroundHoverBg;
    overlayBg = overlayHoverBg;
  }
  if (forceActive) {
    backgroundBg = backgroundActiveBg;
    overlayBg = overlayActiveBg;
  }

  let content;
  if (showIconWithText) {
    content = (
      <Flex alignItems="center">
        <SvgContainer
          mr="5px"
          icon={icon}
          fill={iconFill}
          height={"20px"}
          width={"20px"}
        />
        {children}
      </Flex>
    );
  } else if (children) {
    content = children;
  } else {
    content = <SvgContainer icon={icon} fill={iconFill} size={iconSize} />;
  }

  return (
    <Box
      width={size}
      height={size}
      onClick={onClick}
      bg={backgroundBg}
      position="relative"
      borderRadius={borderRadius}
      transition="background 300ms"
      _hover={{
        bg: backgroundHoverBg
      }}
      _active={{
        bg: backgroundActiveBg
      }}
      {...rest}
    >
      <Box
        _hover={{
          bg: overlayHoverBg
        }}
        _active={{
          bg: overlayActiveBg
        }}
        bg={overlayBg}
        width="100%"
        height="100%"
        borderRadius={borderRadius}
        transition="background 300ms"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {content}
      </Box>
    </Box>
  );
}
